import { atom } from "recoil";
import { SecretNetworkClient } from "secretjs";
import { useChainInfo } from "../hooks/useChainInfo";

export const queryClientState = atom<{
  queryClient: SecretNetworkClient | undefined;
}>({
  key: "queryClientState",
  default: {
    queryClient: new SecretNetworkClient({
      // url: "http://testnet.securesecrets.org:1317",
      url: "https://api.pulsar.scrttestnet.com",
      chainId: "pulsar-2",
    }),
  },
  dangerouslyAllowMutability: true,
});
